import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core";
import iphone from "../../assets/images/iphone.png";
import logo from "../../assets/images/disclaimer.png";

const useStyles = makeStyles(() => ({
  mobileTxt: { position: "absolute", top: "17%", left:'50%', width:'100%', height:'470px', padding:'30px', paddingTop:0,
  transform:'translate(-50%,-10%)',overflowX:'hidden', "&::-webkit-scrollbar":{ width:'12px' } },
  gir2:{ overflow:'hidden', padding: "0 !important", background:'transparent' },
  logo:{
      textAlign:'center',
      marginTop:'40px'
  },
  messageTitle:{
      color: "rgb(0,0,102)",
      fontSize:'18pt',
      textAlign:'center',
      fontWeight:'bold'
  },
  messageBody:{
      maxHeight:"200px",
      minHeight:"190px",
      overflowY:"auto",
      color:'rgb(116,118,129)',
      fontSize:'12pt'
  },
  button:{
    border:'none',
    backgroundColor:'#2262bf',
    borderRadius:'50px',
    padding:'15px',
    width:'90%',
    marginLeft:"12px",
    color:'white',
    fontSize:'14px',
    cursor:'pointer'
  }
}));

export default function DraggableDialog(props) {
  const [content, setContent] = React.useState();
  React.useEffect(() => {
    if (props.data) {
      setContent(props.data);
    }
    if (props.values) {
      setContent(props.values);
    }
    if (props.list) {
      setContent(props.list.content);
    }
  }, []);
  const classes = useStyles();
  return (
    <div>
      <Dialog classes={{paperScrollPaper:"paperScrollPaper"}} open={props.open} onClose={props.handleClose} maxWidth={"xs"}>
        <DialogContent className={classes.gir2} style={{ overflowX: 'hidden' }}>
            <img src={iphone} width="100%" />
            <div className={classes.mobileTxt}>
                <div className={classes.logo}>
                    <img src={logo} alt="Symptom Notification"/>
                </div>
                <br/>
                {content &&
                <>
                <div className={classes.messageTitle}>
                 {props.list?<p>{content.messagetitle}</p>:<p>{content.MessageTitle}</p>}
                </div>
                <br/>
                <div className={classes.messageBody}>
                {props.list?<p>{content.messagebody}</p>:<p>{content.MessageBody}</p>}
                </div>
                <div>
                  <button onClick={props.handleClose} className={classes.button}>Done</button>
                </div>
                </>}
            </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
